<template>

<div>
    <div class="container">
        <form>
 <div class="form-error" v-if="hasError('payment')">*{{ getError('payment') }}</div>
    <div class="row mt-3">
       <order
            v-if="order"
            :states="states"
            :shipping="shipping"
            :billing="billing"
            :stores="allStoresInProximity"
            :sameas="sameas"
            :errors="errors"
            @data-changed="syncOrder"
            @email-changed="emailChanged"
            @zipcode-changed="zipcodeChanged"
            @store-changed="storeChanged"
        >
        </order>

        <inquiry v-if="!order" :states="states" :shipping="shipping" :errors="errors" @data-changed="syncInquiry" @email-changed="emailChanged"></inquiry>

        <div class="col-md-1"></div>
        <div class="col-md-4 payment-totals">
            <checkout-pricing :pricing="localPricing" :loading="priceLoading" :rentnow="order"></checkout-pricing>

            <div v-if="!order">
                <h6 v-if="savings > 0">Ready to Save ${{ formattedSavings }}?</h6>
                <a @click.prevent="toggleOrderInquiry(1)" href="#">Purchase Today!</a>
            </div>

            
            <div class="spacer"></div>
            <div v-if="order && !freeCheckoutEnabled">
                <h3>Credit Card information</h3>
                <div class="form-group">
                    <input type="number" class="form-control" aria-describedby="credit card number" placeholder="" v-model="card.card_number" name="card_number"
                           :class="{'is-invalid': hasError('card.card_number')}">
                    <small class="form-text text-muted">Credit Card Number *</small>
                    <div class="invalid-feedback">
                        The Credit Card Number field is required.
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <select v-model='card.expiration_month' name="expiration_month" class="form-control"
                                :class="{'is-invalid': hasError('card.expiration_month')}">
                            <option v-for="month in monthLabels">{{ month }}</option>
                        </select>
                        <small class="form-text text-muted">Month *</small>
                        <div class="invalid-feedback">
                            The Expiration Month field is required.
                        </div>
                    </div>
                    <div class="col">
                        <select v-model='card.expiration_year' name="expiration_year" class="form-control"
                                :class="{'is-invalid': hasError('card.expiration_year')}">
                            <option v-for="year in years()">{{ year }}</option>
                        </select>
                        <small class="form-text text-muted">Year *</small>
                        <div class="invalid-feedback">
                            The Expiration Year field is required.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <input type="number" class="form-control" aria-describedby="cvv" placeholder="" v-model="card.cvv" name="cvv"
                           :class="{'is-invalid': hasError('card.cvv')}">
                    <small class="form-text text-muted">CVV *</small>
                    <div class="invalid-feedback">
                        The CVV field is required.
                    </div>
                </div>

                </p>
                <div class="row">
                    <div class="col">
                        <div class="secureicon"></div>
                     </div>
                     <div class="col m-0 p-0">
                        <div class="creditcardicon"></div>
                     </div>
                 </div>
                  <div class="spacer"></div>
            </div>


            <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="terms" v-model="terms" aria-describedby="terms"
                       :class="{'is-invalid': hasError('terms')}">
                <label class="form-check-label" for="terms">
                    I confirm I have read and understand the <a href="/disclosure" target="blank">Purchase & Delivery Disclosures</a>, and understand verifiable information related to Housing, Income, and Personal References must be provided prior to delivery.
                </label>
                <div class="invalid-feedback">
                    The terms and conditions must be accepted
                </div>
            </div>
           
            <div class="form-group h-10">
            <div class="spacer"></div>
                <div class="recaptcha2"></div>
                <div class="form-error" v-if="hasError('captcha')">*{{ getError('captcha') }}</div>
            </div>
            <a role="button" class="btn btn-danger mb-4 fullwidth" @click="submitOrder()" v-if="!submitted">Complete Order</a>
            <div class="btn btn-danger mb-4 fullwidth" v-if="submitted">Processing ...</div>
            <div class="disclaimer" v-for="adjustment in pricing.adjustments.messages">
                Savings on (<strong>{{ formatPromoNames(adjustment.promos) }}</strong>) are accumulated over The life of the agreement.
                This code will save you ${{ adjustment.savings }} over {{ adjustment.term }} {{ adjustment.priceLabel }}.
                Model: {{ adjustment.model }}</div>
            </div>
        </div>
        </form>
        </div>
        <div class="spacer"></div>
        <location :location="localLocation"></location>
    </div>
</template>

<script>
import CheckoutPricing from "./CheckoutPricing.vue";
import Order from "./Order.vue";
import Inquiry from "./Inquiry.vue";
import Location from "./Location.vue";

import { ServiceFactory } from "../../../../../../shared/assets/js/services/ServiceFactory";
const PricingService = ServiceFactory.get("pricing");
const OrderService = ServiceFactory.get("order");
const CartService = ServiceFactory.get("cart");
const ActOnEmailCapture = ServiceFactory.get("actOnEmailCapture");
const PromoService = ServiceFactory.get("promos");
const StoreLookupService = ServiceFactory.get("storeLookup");

export default {
  props: ["promos", "pricing", "states", "savings", "location"],

  data() {
    return {
      localPricing: {},
      localLocation: {},
      priceLoading: false,
      order: 1,
      shipping: {},
      billing: {},
      errors: {},
      sameas: false,
      card: {},
      promosMapped: new Map(),
      newsletter: false,
      terms: false,
      submitted: false,
      customerStatus: 'new',
      fulfillmentOption: 'Delivery',
      zipUpdating: false,
      sentActon: false,
      allStoresInProximity: null,
      lastLocationRequestDate: null,

      monthLabels: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
    };
  },

  components: { CheckoutPricing, Order, Inquiry, Location },

  created() {
    this.localLocation = this.location
    this.localPricing = this.pricing;
    this.promosMapped = PromoService.mapPromoCodesToPromos(this.promos);

    console.log('Environment', process.env.NODE_ENV);
    if(process.env.NODE_ENV === 'development') {
      this.shipping = {
        first_name: "Twin_Sun",
        last_name: "Test_Purchase",
        street: "123 Main St",
        city: "Citytown",
        state: "Kentucky",
        zipcode: "72101",
        phone_number: "1234567890",
        birthday: '1/11/11',
      };

      this.sameas = true;

      this.card.card_number = '4111111111111111';
      this.card.expiration_month = '01';
      this.card.expiration_year = new Date().getFullYear() + 1;
      this.card.cvv = '123';
    }
  },

  computed: {
    formattedSavings() {
      return parseFloat(this.savings).toFixed(2);
    },

      freeCheckoutEnabled() {
        if (!this.localPricing || this.localPricing.total >= 0.01) {
            return false;
        }

        return this.localPricing.total < 0.01 && PromoService.freeAtCheckoutPromoCodeExists(this.promos);
      }
  },

  methods: {
    years() {
      const currentYear = new Date().getFullYear();
      let years = [];
      for (let i = currentYear; i <= currentYear + 15; i++) {
        years.push(i);
      }

      return years;
    },

    formatPromoNames(promos) {
      var result = promos.map(function (promo) {
        return PromoService.formatPromoCode(this.promosMapped[promo]);
      }, this);

      return result.toString();
    },

    async toggleOrderInquiry(isOrder) {
      this.priceLoading = true;
      this.order = isOrder;
      const response = await PricingService.get(!!isOrder);
      this.localPricing = response.data;
      this.priceLoading = false;
    },

    syncOrder(order) {
      this.shipping = order.shipping;
      this.billing = order.billing;
      this.sameas = order.sameas;
    },

    emailChanged(email) {
      if (!this.sentActon) {
        this.sentActon = true;
        ActOnEmailCapture.add(email);
      }
    },

    async zipcodeChanged(zipcode) {
      this.zipUpdating = true;
      try {
        const requestDateTime = new Date();
        this.lastLocationRequestDate = requestDateTime;
        const requestTimeUnix = (requestDateTime.getTime()/1000).toString();
        const request = await StoreLookupService.lookup(zipcode, '', false, requestTimeUnix);
        if (!this.validateRequestResponse(request.data)) {
          // This response was received after having sent a newer zipcode request.
          return;
        }
        if (this.hasError("shipping.zipcode")) {
          var errorsScrubbed = JSON.parse(JSON.stringify(this.errors));
          delete errorsScrubbed["shipping.zipcode"];
          this.errors = errorsScrubbed;
        }
        const {allStoresInProximity} = request.data;
        if (allStoresInProximity) {
            this.allStoresInProximity = request.data.allStoresInProximity;
            this.localLocation = null;
        } else {
            this.allStoresInProximity = null;
            this.localLocation = request.data;
            this.$emit("data-changed", { location: this.localLocation });
            await this.toggleOrderInquiry(true);
        }
        this.zipUpdating = false;
      } catch (e) {
        console.log(e.response.data);
        this.errors = e.response.data;
        this.allStoresInProximity = null;
        this.localLocation = null;
        this.zipUpdating = false;
      }
    },

    async storeChanged(store) {
        this.localLocation = store;
        if(!store) {
            return;
        }
        const requestDateTime = new Date();
        this.lastLocationRequestDate = requestDateTime;
        const requestTimeUnix = (requestDateTime.getTime()/1000).toString();
        const request = await StoreLookupService.lookup('', store.id, false, requestTimeUnix);
        this.$emit("data-changed", { location: this.localLocation });
        await this.toggleOrderInquiry(true);
        this.zipUpdating = false;
    },

    syncInquiry(inquiry) {
      this.shipping = inquiry.shipping;
    },

    async submitOrder() {
      if(!this.localLocation || this.zipUpdating || this.submitted) {
          return;
      }

      this.submitted = true;
      let calculatedTotal = this.pricing && this.pricing.total ? this.pricing.total : 0.00;
      let captchaResponse = null;
      if (grecaptcha) {
          captchaResponse = grecaptcha.getResponse();
      }

      //submit form
      let cartContents = await CartService.get();
      let orderFailed = true;

      //1. place order through API via Service class
      //2. fire pixel event if order place succeeds, show
      //   errors if not.
      //3. show completion regardless of pixel outcome
        OrderService.add(
            this.order ? "order" : "inquiry",
            this.terms,
            this.shipping,
            this.billing,
            this.sameas,
            this.card,
            this.newsletter,
            this.customerStatus,
            this.fulfillmentOption,
            calculatedTotal,
            captchaResponse,
        )
            .then((res) => {
                let value = -1.00;
                if (this.localPricing.total) {
                    value = this.localPricing.total;
                }

                const stringRes = res.data.toString();
                const orderId = stringRes.match(/\b\d+$/)[0];
                const ccOrder = {
                    ccEvent: 'orderCompleted',
                    src: 'custom',
                    orderId: orderId,
                    total: calculatedTotal,
                    currency: 'USD',
                };
                window.ccLayer = window.ccLayer || [];
                ccLayer.push(ccOrder);
                this.ccOrder = ccOrder;

                return OrderService.firePixelEvent(cartContents.data, value, this.shipping.email_address);
            }, (error) => {
                orderFailed = true;

                console.log('Order Place failed, not firing Pixel event.');
                console.log(error.response.data);

                throw error;
            })
            .then((result) => {
                console.log('Did dispatch Pixel event post-purchase: ', result);
            }, (reason) => {
                console.log('Pixel event post-purchase failed: ', reason);
                throw reason;
            })
            .then(() => {
                this.navigateToCompleteScreen();
            }, (error) => {
                if (orderFailed) {
                    this.submitted = false;
                    console.log('error: ', JSON.stringify(error.response.data));
                    this.errors = error.response.data;

                    if (this.errors && this.errors.captcha && grecaptcha) {
                        grecaptcha.reset();
                    }
                } else {
                    //We can fail pixel, but not the order itself, so we'll still proceed to checkout
                    this.navigateToCompleteScreen();
                }
            });
    },

    navigateToCompleteScreen() {
        if (this.order) {
            const ccOrderJson = JSON.stringify(this.ccOrder);
            const ccOrderJsonEncoded = btoa(ccOrderJson);
            window.location.replace("/order/complete?dl=" + ccOrderJsonEncoded);
        } else {
            window.location.replace("/inquiry/complete");
        }
    },

    hasError(field) {
      if (this.errors[field]) {
        return true;
      }

      return false;
    },

    getError(field) {
      if (!this.hasError(field)) {
        return;
      }

      return this.errors[field][0];
    },

    validateRequestResponse(responseData) {
      const requestTimestamp = responseData.request_time;
      const requestDate = new Date(requestTimestamp * 1000);
      return requestDate >= this.lastLocationRequestDate;
    }
  },
};
</script>
